import type { DatasetZoomModalActionsProps } from "./dataset-zoom-modal-actions.type";

import { Button } from "antd";
import { useTranslation } from "react-i18next";

import DatasetDeleteMutatorButton from "@/modules/dataset/dataset-delete-mutator-button";
import {
  useDatasetsMutatorDatasetTypeStatus,
  useDatasetsMutatorStatus,
} from "@/modules/datasets/datasets-mutator";
import DatasetsMutatorCancelButton from "@/modules/datasets/datasets-mutator-cancel-button";
import DatasetsMutatorSaveButton from "@/modules/datasets/datasets-mutator-save-button";

import "./dataset-zoom-modal-actions.style.less";

const DatasetZoomModalActions = ({
  datasetType,
  dataset,
  loading,
  disabled,
  onCancelClick,
  onSaveClick,
  onCloseClick,
}: DatasetZoomModalActionsProps) => {
  const { t } = useTranslation();
  const { isDirty } = useDatasetsMutatorStatus();
  const { toBeDeleted, isSaving } =
    useDatasetsMutatorDatasetTypeStatus(datasetType);

  if (disabled) {
    return <Button onClick={onCloseClick}>{t("global:close")}</Button>;
  }

  const showDeleteButton = dataset && !loading && !isSaving && !toBeDeleted;

  return (
    <div className="dataset-zoom-modal-actions">
      {showDeleteButton && <DatasetDeleteMutatorButton dataset={dataset} />}
      {!isDirty && <Button onClick={onCloseClick}>{t("global:close")}</Button>}
      <DatasetsMutatorCancelButton onClick={onCancelClick} />
      <DatasetsMutatorSaveButton onClick={onSaveClick} />
    </div>
  );
};

export default DatasetZoomModalActions;
